import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetStatsQuery } from '@platform/state/api';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { cx } from '@platform/core/lib/cx';
import { openClosedOf } from '@platform/core/lib/recordCounts';
import { routes } from '@platform/core/lib/routes';
import { menuLinkActive } from './menuLinkActive';
import { isDesigned, tableEntryKeyOf } from './moduleSections';
import type { ITableMenuItemProps } from './ITableMenuItemProps';

/**
 * Пункт секції «Таблиці»: реалізована таблиця відкриває «Усі записи» з кількістю записів праворуч (у підказці — «відкрито · усього» зі
 * статистики за статусами); спроєктована — приглушений пункт без лічильника, що відкриває «Записи й форми» модуля з підсвіченим типом
 * (прототип v4 goDesign → cmFocus) і активний там. Назва в один рядок (повна — у підказці).
 */
export function TableMenuItem({ ws, moduleKey, rt, active }: ITableMenuItemProps) {
  const { t } = useTranslation();
  const strings = useModuleStrings();
  const { pathname, search } = useLocation();
  const designed = isDesigned(rt);
  const { data } = useGetStatsQuery({ ws, rt: rt.key, by: 'status', params: {} }, { skip: designed });
  const counts = openClosedOf(data, rt.statuses);
  const name = strings.entity(rt.key, 'name', rt.name);
  const item = tableEntryKeyOf(rt);
  const to = designed ? routes.moduleSettings(moduleKey, 'records', rt.key) : routes.list(moduleKey, rt.key, item === 'view:table' ? 'table' : undefined, item);
  const on = designed ? menuLinkActive(to, pathname, search) : active;
  return (
    <Link className={cx('mnav__item', designed && 'is-muted', on && 'is-active')} aria-current={on ? 'page' : undefined} to={to}>
      <span className="mnav__label" title={name}>{name}</span>
      {!designed && data && <span className="mnav__count" title={t('menu.counts', { open: counts.open, total: counts.total })}>{counts.total}</span>}
    </Link>
  );
}
